import React from "react";
import "../styles/Header.css";

const Header = () => {
  return (
    <div className="header">
      <h1 className="headerText">Ultimate Tic Tac Toe AI</h1>
    </div>
  );
}

export default Header;
